import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { directoryPages } from '../../data/pages';
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  return <header className="fixed inset-x-0 top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur" data-id="element-29" data-mp="19r6x6a1ht7yr">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-6 py-4 lg:px-10" data-id="element-30" data-mp="lyqhu7953u35">
        <Link to="/" onClick={() => setIsOpen(false)} className="flex flex-col leading-tight" data-id="element-31" data-mp="hx4yc323ohjz">
          <span className="font-heading text-lg font-semibold tracking-wide text-navy sm:text-xl" data-id="element-32" data-mp="vspfasy9qpor">
            ELIJAH GERSON
          </span>
          <span className="text-[11px] font-medium uppercase tracking-[0.14em] text-brandgreen" data-id="element-33" data-mp="39tk1tejajg6">
            Energy Transition &amp; Strategy Leader
          </span>
        </Link>

        <button type="button" onClick={() => setIsOpen(prev => !prev)} className="flex items-center gap-2 rounded-md border border-slate-200 px-4 py-2.5 text-sm font-semibold text-navy transition-colors duration-150 hover:border-brandgreen/50" aria-expanded={isOpen} aria-controls="site-directory" data-id="element-34" data-mp="6von3uv7wz3t">
          {isOpen ? <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-35" data-mp="lme1t77w0wcf" /> : <MenuIcon className="h-4 w-4" aria-hidden="true" data-id="element-36" data-mp="3k3rt5omr58mm" />}
          Directory
        </button>
      </div>

      <AnimatePresence data-id="element-37" data-mp="3p34okxrovo0t">
        {isOpen && <motion.div id="site-directory" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden border-b border-slate-200 bg-white" data-id="element-38" data-mp="3tzbjzwmglh4i">
            <div className="mx-auto max-w-7xl px-6 py-8 lg:px-10" data-id="element-39" data-mp="1ddlhdq0067zd">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brandgreen" data-id="element-40" data-mp="3aatvvoqifsw1">
                Nine sections, each with a single purpose
              </p>
              <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-41" data-mp="3jc0cdxt5t3pa">
                {directoryPages.map((page, index) => {
              const isActive = location.pathname === page.path;
              return <Link key={page.path} to={page.path} onClick={() => setIsOpen(false)} className={`flex items-start gap-3 rounded-lg border p-4 transition-colors duration-150 ${isActive ? 'border-brandgreen bg-ice' : 'border-slate-200 hover:border-brandgreen/50'}`} data-id="element-42" data-mp="2qmbc5mo9x7oq" data-mpi={index}>
                      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-navy text-xs font-semibold text-white" data-id="element-43" data-mp="22z32ytnq5ehf">
                        {index + 1}
                      </span>
                      <span data-id="element-44" data-mp="n7r3mamff4nq">
                        <span className="block text-sm font-semibold text-navy" data-id="element-45" data-mp="n926m881s8ds">{page.title}</span>
                        <span className="mt-1 block text-xs leading-relaxed text-slate-500" data-id="element-46" data-mp="9hnr4bdcmpbh">{page.description}</span>
                      </span>
                    </Link>;
            })}
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}